module.exports = __webpack_public_path__ + "img/20180815_151844_199.7520dc4e.jpg";